<template>
  <div class="brand-selection-section">
    <h2 class="section-title"></h2>
    <div class="products-layout-container">
      <div class="products-scroll-viewport">
        <div class="products-grid">
          <ProductCard
            v-for="product in products"
            :key="product.id"
            @click="goToDetail(product.id)"
            :image-url="product.imageUrl"
            :name="product.name"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import frontServer from '../../../services/FrontManage'
import ProductCard from './ProductCard.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const goToDetail = (id) => {
  router.push({ name: 'ShoeDetail', params: { id } })
}

const products = ref([])

onMounted(async () => {
  try {
    const result = await frontServer.GetSubPicture();
    if (result && result.subGroup1Goods) {
      const baseConfig = result.subGroup1Goods;
      products.value = baseConfig.map(item => ({
        id: item.id || '', // 确保有 id
        imageUrl: item.mainImage ? `${process.env.VUE_APP_BACKEND_BASE_URL}/${item.mainImage}` : 'https://via.placeholder.com/500?text=No+Image', // 處理圖片可能為空的情況
        // name: item.name || 'Product Name' // 如果需要 name
      }));
    } else {
      console.warn('subGroup1Goods not found in API response or result is invalid.');
      products.value = []; // 或者設置一些默認的佔位產品
    }
  } catch (error) {
    console.error('Failed to load subGroup1Goods:', error);
    products.value = []; // 出錯時清空或設置佔位
  }
});
</script>

<style scoped>
.brand-selection-section {
  padding: 80px 0;
  text-align: center;
  background-color: #fff;
  overflow: hidden;
}

.section-title {
  font-size: 40px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 30px;
  display: inline-block;
  padding-bottom: 8px;
  border-bottom: 3px solid #000000;
}

.products-layout-container {
  margin: 0 auto;
  padding: 0 20px; /* 桌面端左右內邊距 */
  box-sizing: border-box;
}

.products-scroll-viewport {
  width: 100%;
  overflow-x: auto; /* 改为 auto，允许在内容超出时水平滚动 */
  text-align: center; /* 依然尝试居中，但如果内容宽度超过视口，滚动会优先 */
  -webkit-overflow-scrolling: touch; /* iOS 滚动优化 */
  scrollbar-width: thin; /* Firefox 细滚动条 */
  scrollbar-color: rgba(0,0,0,0.2) rgba(0,0,0,0.05); /* Firefox 滚动条颜色 */
}
/* Webkit 浏览器 (Chrome, Safari, Edge) 滚动条样式 */
.products-scroll-viewport::-webkit-scrollbar {
  height: 8px; /* 水平滚动条高度 */
}
.products-scroll-viewport::-webkit-scrollbar-track {
  background: rgba(0,0,0,0.05);
  border-radius: 4px;
}
.products-scroll-viewport::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.2);
  border-radius: 4px;
}


.products-grid {
  display: inline-flex; /* 保持 inline-flex 使内容宽度由子元素决定 */
  flex-wrap: nowrap;
  padding: 20px 0; /* 给滚动内容一些垂直内边距 */
  gap: 0; /* 移除 gap，因为 scale 可能会导致间距问题，由卡片自身 padding 控制间距 */
}

/* 桌面端卡片缩放 */
.products-grid > :deep(.product-card) { /* 使用 :deep() 穿透到子组件的 .product-card */
  transform: scale(0.75);
  transform-origin: center center; /* 确保从中心缩放 */
  margin: -50px -60px; /* 负 margin 来补偿 scale 造成的额外空间，需要仔细调试 */
                        /* 这个值非常依赖 ProductCard 的原始大小和 scale 比例 */
                        /* 例如：如果原始卡片寬500，縮放0.75後為375，寬度減少125，所以左右各補 -125/2 = -62.5 */
                        /* 高度同理 */
}


/* 响应式调整 */
@media (max-width: 1200px) {
  .products-grid > :deep(.product-card) {
    transform: scale(0.7); /* 中等屏幕可以稍微再小一点或保持 */
    margin: -60px -70px; /* 调整负 margin */
  }
}

@media (max-width: 992px) {
  .section-title {
    font-size: 32px; /* 减小标题字体 */
    margin-bottom: 25px;
  }
  .brand-selection-section {
    padding: 60px 0; /* 减小整体上下内边距 */
  }
  .products-grid > :deep(.product-card) {
    transform: scale(0.65);
    margin: -70px -80px;
  }
}

@media (max-width: 768px) {
  .products-layout-container {
    padding: 0 10px; /* 减小移动端左右内边距 */
  }
  .section-title {
    font-size: 28px;
    margin-bottom: 20px;
  }
  .products-grid {
    padding: 10px 0; /* 减小滚动区垂直内边距 */
  }
  /* 在移动端，通常我们不希望卡片被缩放，或者缩放比例接近1，以保证可读性和触摸交互 */
  .products-grid > :deep(.product-card) {
    transform: scale(1); /* 移动端恢复正常大小 */
    margin: 0 10px;      /* 使用正常的 margin 来控制卡片间距 */
                         /* 注意：此时 ProductCard 自身的媒体查询会生效，控制其大小 */
  }
}

@media (max-width: 576px) {
  .section-title {
    font-size: 24px;
  }
  .brand-selection-section {
    padding: 40px 0;
  }
   .products-grid > :deep(.product-card) {
    margin: 0 8px; /* 进一步调整小屏幕间距 */
  }
}
</style>